// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3E4RE","choiceBoxes":"toolbarselects_choiceBoxes__3F0yp","simpleField":"toolbarselects_simpleField__NGHxX"};